import * as React from "react";
import { MapsProps, MapsInjectedProps } from "../typings";
import ModuleMap, { MapContext } from "../ModuleMap";
import { inject, observer } from "mobx-react";
import { withLocalization } from "bernie-l10n";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";

const DynamicMaps: React.FC<MapsProps> = (props: MapsProps & MapsInjectedProps) => {
  const shouldOpenMapInHSR = false;
  const sendUserToHSR = false;
  const toggleShowFullscreenMap = () => null;

  return (
    <div
      className="Maps uitk-flex uitk-cell all-cell-1-1 all-y-padding-three"
      id={props.flexComponent.id}
      data-fm={props.flexComponent.fmId}
      data-fm-title-id={props.flexComponent.fmTitleId}
    >
      <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
        <div className="uitk-flex dynamicMap" data-testid="dynamic-map">
          <MapContext.Provider
            value={{
              toggleShowFullscreenMap,
              sendUserToHSR,
              shouldOpenMapInHSR
            }}
          >
            <ModuleMap
              {...props}
              classNames="uitk-dialog-content uitk-dynamic-map"
              isDynamic={true}
            />
          </MapContext.Provider>
        </div>
      </UitkFigure>
    </div>
  );
};

export const Maps = withLocalization<MapsProps, React.FC<MapsProps>>(
  inject("analytics", "hotels", "poi")(observer(DynamicMaps))
);

Maps.displayName = "DynamicMaps";

export default Maps;
